import type { api } from "~/utils/api";

type TaskUtils = ReturnType<typeof api.useUtils>["task"];
// predicate/queryKey are typed per-procedure, so Omit them to keep a shape assignable to all three invalidates.
type InvalidateFilters = Omit<
  NonNullable<Parameters<TaskUtils["getSearchResults"]["invalidate"]>[1]>,
  "predicate" | "queryKey"
>;

// getGroupedSearchCounts and getSearchResultsCount are separate task-derived caches: a mutation that
// changes the row set must refresh both, or grouped headers and the total count drift from the rows.
export function invalidateTaskSearch(task: TaskUtils, filters?: InvalidateFilters): Promise<unknown> {
  return Promise.all([
    task.getSearchResults.invalidate(undefined, filters),
    task.getGroupedSearchCounts.invalidate(undefined, filters),
    task.getSearchResultsCount.invalidate(undefined, filters),
  ]);
}
